import { motion, useReducedMotion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", as = "div" }) => {
  const reduce = useReducedMotion();
  const M = motion[as];
  if (reduce) return <M className={className}>{children}</M>;
  return (
    <M
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.12 }}
      transition={{ duration: 0.9, ease: EASE, delay }}
    >
      {children}
    </M>
  );
};

export const Eyebrow = ({ children, dark = false, className = "" }) => (
  <p className={`flex items-center gap-3 text-xs font-bold uppercase tracking-[0.28em] ${dark ? "text-sky-300" : "text-sky-700"} ${className}`}>
    <span className={`h-px w-8 ${dark ? "bg-sky-300/70" : "bg-sky-700/60"}`} />
    {children}
  </p>
);

export const Ph = ({ children, dark = false }) => (
  <span
    data-testid="admin-placeholder"
    className={`inline-flex items-center gap-1.5 rounded-sm border border-dashed px-2 py-0.5 align-middle text-xs font-semibold ${
      dark ? "border-amber-300/60 bg-amber-300/10 text-amber-200" : "border-amber-600/50 bg-amber-50 text-amber-800"
    }`}
  >
    <span className="uppercase tracking-wider opacity-80">Admin</span>
    {children}
  </span>
);

export const Btn = ({ href, onClick, children, variant = "primary", className = "", testid, external, ...rest }) => {
  const base =
    "group relative inline-flex items-center justify-center gap-2 overflow-hidden rounded-full px-7 py-4 text-sm font-bold tracking-wide transition-[background-color,color,border-color,transform] duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sky-300 focus-visible:ring-offset-2 active:scale-[0.98]";
  const styles = {
    primary: "bg-white text-navy hover:bg-sky-100",
    navy: "bg-navy text-white hover:bg-navy-700",
    ghost: "border border-white/40 text-white hover:border-white hover:bg-white/10",
    outline: "border border-navy/25 text-navy hover:border-navy hover:bg-navy hover:text-white",
  };
  return (
    <a
      href={href}
      onClick={onClick}
      data-testid={testid}
      className={`${base} ${styles[variant]} ${className}`}
      {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      {...rest}
    >
      {children}
    </a>
  );
};
